export function Add() {
  return (
    <path
      d="M77 85a1 1 0 001 1h5.833a.167.167 0 01.167.167V92a1 1 0 002 0v-5.833a.167.167 0 01.167-.167H92a1 1 0 000-2h-5.833a.167.167 0 01-.167-.167V78a1 1 0 00-2 0v5.833a.167.167 0 01-.167.167H78a1 1 0 00-1 1z"
      fill="var(--color-border-accent)"
    />
  );
}
